module.exports = __webpack_public_path__ + "a48ae63278dbc7b70ce9d446a13efc0f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/surfboard.png
// module id = 1608
// module chunks = 0